<app-spinner [isEnable]="isSpinnerEnabled" loaderClass="download-report-spinner"></app-spinner>
<div *ngIf="individualBriefReport$ | async as individualBriefReport">
<div class="brief-report" [hidden]="isDetailedReport">
  <div class="card b-0 base-shadow-list m-b-10" #individualReportContent>

    {{ getIndividualReportData(individualBriefReport) }}
    <div  class="card-body" id="brief-report" [attr.processId]="processId" [attr.appraiseeId]="appraiseeId">
      <div class="row mb-2">
        <div class="col-6">
          <app-appraisee-info-module [isIndividualBriefReport]="true" [employeeInfoReport]="individualBriefReport.employeeInfo"
            [endDate]="individualBriefReport.processInfo.endDate"></app-appraisee-info-module>

          <app-report-description-module [processInfoReport]="individualBriefReport.processInfo"></app-report-description-module>

          <app-overall-rating-module *ngIf="individualBriefReport.overallRating" [overallRating]="individualBriefReport.overallRating"
            [scaleDescription]="individualBriefReport.processInfo.scaleDescription"></app-overall-rating-module>

          <app-satisfaction-rate-module [satisfactions]="individualBriefReport.satisfactionRateQuestions"></app-satisfaction-rate-module>
        </div>
        <div class="col-6">
          <app-common-report-result [generalReportInfo]="individualBriefReport.generalReportInfo"></app-common-report-result>

          <app-respondents-by-grade-module *ngIf="individualBriefReport.processGrades && individualBriefReport.processGrades.length>0"
            [processGrades]="individualBriefReport.processGrades"></app-respondents-by-grade-module>

          <app-respondents-by-category-module *ngIf="individualBriefReport.respondentCategories && individualBriefReport.respondentCategories.length>0"
            [respondentCategories]="individualBriefReport.respondentCategories"></app-respondents-by-category-module>

          <app-question-categories-rating-module *ngIf="individualBriefReport.questionCategoryRates && individualBriefReport.questionCategoryRates.length>0"
            [questionCategoryRates]="individualBriefReport.questionCategoryRates"></app-question-categories-rating-module>
        </div>
        <div class="col-12" style="page-break-inside: avoid">

          <app-strong-weak-sides-module [weakestSides]="individualBriefReport.weakestSides" [strongestSides]="individualBriefReport.strongestSides"></app-strong-weak-sides-module>
        </div>

        <div class="col-12">
          <app-appraisee-info-module hidden style="page-break-before: always" [employeeInfoReport]="individualBriefReport.employeeInfo"
            [endDate]="individualBriefReport.processInfo.endDate"></app-appraisee-info-module>

          <app-report-description-module hidden [processInfoReport]="individualBriefReport.processInfo"></app-report-description-module>

          <app-text-questions-module [textQuestionCategories]="individualBriefReport.textQuestionCategories">

          </app-text-questions-module>
        </div>
      </div>
    </div>
  </div>
</div>
  <div *ngIf="individualDetailedReport$ | async as individualDetailedReport">
  <div [hidden]="!isDetailedReport">
    <div class="card" #detailedReportContent >
    <div class="card-body detailed-report">
      <div class="row">
      <app-appraisee-info-module [isIndividualBriefReport]="false" class="col-6" [employeeInfoReport]="individualDetailedReport.employeeInfo"></app-appraisee-info-module>
      <app-report-description-module [isIndividualBriefReport]="false" class="col-4" [processInfoReport]="individualBriefReport.processInfo"></app-report-description-module>
      </div>
      <app-detailed-report-faq [isCombinedReport] = "false"></app-detailed-report-faq>
      <app-categories [detailReportCategories]="individualDetailedReport.categories"></app-categories>
    </div>
  </div>
  </div>
</div>
